// Запрет вызова сообщения о необходимости установить расширение cadesplugin_api.js
if (!window.cadesplugin_skip_extension_install) {
  window.cadesplugin_skip_extension_install = true
}
